import React from "react";
import styled from "styled-components";
import RemediationIndicator from "./RemediationIndicator";
import { Icon } from "@fluentui/react";

const RemediationContentUI: React.FC<{ level?: string; text: string }> = ({ level, text }) => (
  <Wrap>
    <Icon iconName="complexity" />
    <Text>{text}</Text>
    <RemediationIndicator level={level || "none"} />
  </Wrap>
);

const Wrap = styled.div`
  display: flex;
  gap: 8px;
  align-items: baseline;

  .remediation-indicator {
    align-items: flex-end;
  }
`;

const Text = styled.span`
  font-weight: 600;
`;

export default RemediationContentUI;
